import * as React from 'react'
import * as ReactDOM from 'react-dom'

export {jsxDEV} from 'react/jsx-dev-runtime'
export * from 'react/jsx-runtime'
export * from 'react-dom/client'

import * as ReactRouterDOM from 'react-router-dom'
export {React, ReactDOM, ReactRouterDOM}
